const types = {
    LOGIN_REQUEST: 'auth/LOGIN',
    LOGOUT_REQUEST: 'auth/LOGOUT',
};

export default types;
